"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnqueueSnackbar = void 0;
var notistack_1 = require("notistack");
/**
 * @deprecated このフックは非推奨です。代わりに useToast を使用してください
 */
var useEnqueueSnackbar = function () {
    var enqSnackbar = (0, notistack_1.useSnackbar)().enqueueSnackbar;
    var enqueueSnackbar = function (message, options) {
        var _a;
        enqSnackbar(message, __assign(__assign({}, options), { variant: (_a = options === null || options === void 0 ? void 0 : options.variant) !== null && _a !== void 0 ? _a : "success" }));
    };
    return enqueueSnackbar;
};
exports.useEnqueueSnackbar = useEnqueueSnackbar;
